// @ts-nocheck
import React from 'react';
import initialState from '/home/hcqadmin/HCQ-Application/src/.umi/plugin-initial-state/models/initialState';
import model0 from "/home/hcqadmin/HCQ-Application/src/models/client";
import model1 from "/home/hcqadmin/HCQ-Application/src/models/location";
import model2 from "/home/hcqadmin/HCQ-Application/src/models/question";
import model3 from "/home/hcqadmin/HCQ-Application/src/models/quote";
import model4 from "/home/hcqadmin/HCQ-Application/src/models/staff";
import model5 from "/home/hcqadmin/HCQ-Application/src/models/term";
// @ts-ignore
import Dispatcher from './helpers/dispatcher';
// @ts-ignore
import Executor from './helpers/executor';
// @ts-ignore
import { UmiContext } from './helpers/constant';

export const models = { '@@initialState': initialState, 'client': model0, 'question': model2, 'quote': model3, 'location': model1, 'staff': model4, 'term': model5 };

export type Model<T extends keyof typeof models> = {
  [key in keyof typeof models]: ReturnType<typeof models[T]>;
};

export type Models<T extends keyof typeof models> = Model<T>[T]

const dispatcher = new Dispatcher!();
const Exe = Executor!;

export default ({ children }: { children: React.ReactNode }) => {

  return (
    <UmiContext.Provider value={dispatcher}>
      {
        Object.entries(models).map(pair => (
          <Exe key={pair[0]} namespace={pair[0]} hook={pair[1] as any} onUpdate={(val: any) => {
            const [ns] = pair as [keyof typeof models, any];
            dispatcher.data[ns] = val;
            dispatcher.update(ns);
          }} />
        ))
      }
      {children}
    </UmiContext.Provider>
  )
}
